/**
 * User-friendly Persian fallback messages for the normalized error layer
 * (createResponseErrorInterceptor). Keyed by HTTP status code, plus `default`
 * and `offline`. When the API supplies its own message it is used as-is;
 * otherwise the request is mapped to one of these so the UI never surfaces a
 * raw English Axios string like "Request failed with status code 404".
 */
export const generalErrors: Record<string, string> = {
    default: 'خطایی رخ داد. لطفاً دوباره تلاش کنید.',
    offline: 'اتصال اینترنت برقرار نیست. اتصال خود را بررسی کنید.',
    400: 'درخواست نامعتبر است.',
    401: 'برای ادامه باید وارد شوید.',
    403: 'اجازه‌ی دسترسی به این بخش را ندارید.',
    404: 'موردی یافت نشد.',
    408: 'زمان درخواست به پایان رسید. دوباره تلاش کنید.',
    409: 'این عملیات با وضعیت فعلی تداخل دارد.',
    422: 'اطلاعات واردشده معتبر نیست.',
    423: 'دسترسی موقتاً قفل شده است.',
    429: 'تعداد درخواست‌ها زیاد است. کمی صبر کنید.',
    500: 'خطای داخلی سرور. لطفاً بعداً تلاش کنید.',
    502: 'سرور در دسترس نیست. لطفاً بعداً تلاش کنید.',
    503: 'سرویس موقتاً در دسترس نیست. لطفاً بعداً تلاش کنید.',
    504: 'پاسخ سرور با تأخیر مواجه شد. دوباره تلاش کنید.',
};
